// Generated by generate.mjs. Edit orb-math.ts, then regenerate.
export const nodeCount = 17,
  signalCount = 3;
export const edges: [number, number][] = [
  [0, 1],
  [0, 2],
  [0, 3],
  [0, 4],
  [0, 5],
  [0, 6],
  [0, 8],
  [1, 2],
  [1, 3],
  [1, 4],
  [1, 6],
  [1, 9],
  [2, 4],
  [2, 5],
  [2, 7],
  [2, 10],
  [3, 5],
  [3, 6],
  [3, 8],
  [3, 11],
  [4, 7],
  [4, 9],
  [4, 12],
  [5, 7],
  [5, 8],
  [5, 10],
  [5, 13],
  [6, 8],
  [6, 9],
  [6, 11],
  [6, 14],
  [7, 10],
  [7, 12],
  [7, 15],
  [8, 11],
  [8, 13],
  [8, 16],
  [9, 11],
  [9, 12],
  [9, 14],
  [10, 13],
  [10, 15],
  [10, 16],
  [11, 13],
  [11, 14],
  [11, 16],
  [12, 14],
  [12, 15],
  [12, 16],
  [13, 15],
  [13, 16],
  [14, 15],
  [14, 16],
  [15, 16],
];
export const routes: [number, number][][] = [
  [
    [0, 1],
    [2, 5],
    [5, 8],
    [6, 11],
    [9, 12],
    [0, 1],
    [1, 9],
    [5, 10],
    [5, 10],
    [8, 11],
    [10, 15],
    [0, 5],
    [3, 6],
    [5, 10],
    [14, 16],
    [11, 14],
    [11, 14],
    [1, 4],
    [6, 9],
    [9, 14],
    [0, 1],
  ],
  [
    [3, 6],
    [7, 10],
    [8, 13],
    [11, 14],
    [0, 2],
    [3, 11],
    [5, 13],
    [8, 13],
    [11, 16],
    [0, 5],
    [0, 5],
    [2, 7],
    [10, 13],
    [0, 1],
    [3, 6],
    [0, 3],
    [1, 6],
    [2, 10],
    [9, 12],
    [13, 15],
    [3, 6],
  ],
  [
    [8, 13],
    [12, 15],
    [14, 16],
    [1, 3],
    [2, 10],
    [6, 14],
    [9, 12],
    [13, 16],
    [4, 9],
    [3, 11],
    [4, 7],
    [10, 13],
    [0, 2],
    [0, 3],
    [3, 8],
    [6, 11],
    [9, 14],
    [7, 15],
    [10, 15],
    [4, 7],
    [8, 13],
  ],
];
